{
    "filter_menu_title__sales_rep": "Vertreter",
    "filter_menu_title__city": "Stadt",
    "filter_menu_title__zip_code": "PLZ",
    "filter_menu_title__industry": "Branche",
    "filter_menu_title__insights": "Vertriebsempfehlungen",
    "filter_menu_title__status": "Status",
    "filter_menu_title__company": "Verkaufsstandort",
    "filter_menu_title__customer_class": "Kundenart",
    "filter_menu_title__sales_region": "Vertriebsregion",
    "filter_menu_title__customer": "Kunde",
    "insight_type__cross_sell": "Cross-Sell Empfehlungen",
    "insight_type__churn_warning": "Abwanderungswarnungen",
    "insight_type__global_churn_warning": "Abwanderung in >1 Produktgruppen",
    "insight_type__first_purchase": "Erster Kauf in Warengruppe",
    "insight_type__share_of_wallet": "Umsatzpotenzial nicht ausgeschöpft",
    "insight_type__previously_purchased": "Früher Bestellt",
    "insight_type__industry_top": "Top in der Branche",
    "insight_type__global_top": "Top über alle Branchen",
    "customer_search_placeholder": "Suche nach Name, Kundennr., PLZ, Ort",
    "table_header__name": "Kunde",
    "table_header__ttm_current": "Umsatz 12 Monate",
    "table_header__order_sum_ttm_current": "Auftragseingang 12 Monate",
    "table_header__ttm_delta": "Abweichung 12 Monate",
    "table_header__revenue_ytd": "Umsatz Laufendes Jahr",
    "table_header__order_sum_ytd": "Auftragseingang Laufendes Jahr",
    "table_header__revenue_ytd_delta": "Abweichung Vorjahr",
    "table_header__last_order_date": "Letzter Auftrag",
    "table_header__primary_rep": "Vertreter",
    "table_header__city": "Stadt",
    "table_header__industry": "Branche",
    "table_header__status": "Status",
    "table_header__expansion_potential": "Ausbaupotenzial",
    "table_header__revenue_decline": "Abwanderungen",
    "table_header__gm_ttm": "DB 12 Monate",
    "table_header__gm_ttm_percent": "DB % 12 Monate",
    "table_header__gm_ttm_delta": "Abweichung DB 12 Monate",
    "table_header__gm_ytd": "DB Laufendes Jahr",
    "table_header__gm_ytd_percent": "DB % Laufendes Jahr",
    "table_header__gm_ytd_delta": "Abweichung DB Laufendes Jahr",
    "status_new": "Neu",
    "status_active": "Aktiv",
    "status_at_risk": "Gefährdet",
    "status_inactive": "Inaktiv",
    "status_blocked": "Gesperrt",
    "status_dormant": "Ruhend",
    "status_tooltip": "Plato hilft dir Kunden zu priorisieren und teilt diese in fünf Kategorien, basierend auf Bestellverhalten und Risikosignalen, ein:",
    "status_tooltip_new": "hat gerade erst angefangen zu bestellen",
    "status_tooltip_active": "bestellt regelmäßig",
    "status_tooltip_at_risk": "zeigt Abwanderungstendenzen",
    "status_tooltip_dormant": "keine Bestellungen in 6+ Monaten",
    "status_tooltip_inactive": "manuell als inaktiv markiert",
    "table_footer__sum": "Summe",
    "table_header__visit_count": "Dokumentierte Besuche",
    "table_header__visits_per_100k": "Besuche / 100 T€",
    "visits_per_100k_tooltip": "Anzahl der Besuche pro 100.000 € Umsatz über die letzten 12 Monate. Zeigt, ob der Besuchsaufwand zur Kundengröße passt – hilfreich, um kleine Kunden mit vielen Besuchen und zu selten besuchte große Kunden zu erkennen. Als „nicht angetroffen“ erfasste Besuche zählen nicht. Wird nur bei Kunden mit mindestens 1.000 € Umsatz berechnet.",
    "table_header__last_visit": "Letzter Besuch",
    "last_visit_tooltip": "Datum des letzten Besuchs bei diesem Kunden."
}
